import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  title: {
    margin: theme.spacing(1),
    marginBottom: 3
  },
  drawerItems: {
    padding: theme.spacing(1),
  },
  guesttypeDividerFixed: {
    marginBottom: '10px',
    marginRight: '20px',
    marginLeft: '20px',
  },
  btnControl: {
    margin: theme.spacing(2),
    float: "right",
    right: '10px',
  },
  flexInput: {
    flexGrow: "1"
  },

  guesttypeDividerBottom: {
    marginBottom: '15px'
  },
  guesttypeDividerTop: {
    marginTop: '15px'
  },
  guesttypesDrawer: {
    display: "inline-block",
    [theme.breakpoints.up('sm')]: {
      width: "500px",
      flexShrink: 0,
    },
    [theme.breakpoints.down('sm')]: {
      width: "100%",
      flexShrink: 0,
    },
  },
  guesttypeBox: {
    padding: '10px',
    height: "calc(100vh - 100px)",
    overflowY: 'auto',
    overflowX: 'hidden'
  },
  drawerDetailConfiguration: {
    [theme.breakpoints.up('sm')]: {
      width: "500px",
      flexShrink: 0,
    },
    [theme.breakpoints.down('sm')]: {
      width: "100%",
      flexShrink: 0,
    },
  },
}));
